import { ShopSettings } from "~/types";

export default function useSettingsShop(  shopSettings  : ShopSettings) 
{
    const redPriceProduct : boolean = shopSettings != null && shopSettings.priceRed != null ? shopSettings.priceRed : false;
    const redPriceStock: boolean = shopSettings != null && shopSettings.priceRedStock != null ? shopSettings.priceRedStock : false;
    const hideProductRangeBreadcumb : boolean = shopSettings != null && shopSettings.hideProductRangeBreadcumb != null ? shopSettings.hideProductRangeBreadcumb : false;
    const hideBrandBreadcumb : boolean = shopSettings != null && shopSettings.hideBrandBreadcumb != null ? shopSettings.hideBrandBreadcumb : false;
    const requestCustomization : boolean = shopSettings != null && shopSettings.askForPriceForm != null ? shopSettings.askForPriceForm : false;
    const requestPrice : boolean = shopSettings != null && shopSettings.askForPriceDefaultForm != null ? shopSettings.askForPriceDefaultForm : false;
    const enableProductDetailsTab :boolean = shopSettings != null && shopSettings.enableProductDetailsTab != null ?  shopSettings.enableProductDetailsTab : false;
    const askforpriceMessage : string = shopSettings != null && shopSettings.askForPriceMessage != null ? shopSettings.askForPriceMessage : "";

    return {
        redPriceProduct,
        redPriceStock,
        hideBrandBreadcumb, 
        hideProductRangeBreadcumb,
        requestCustomization,
        requestPrice,
        askforpriceMessage,
        enableProductDetailsTab
    }
}
